var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.status === undefined || _vm.row.status<0)?[_vm._v("/")]:[_c('el-tag',{attrs:{"size":"mini","type":_vm.options[_vm.row.status].tagType}},[_vm._v(_vm._s(_vm.options[_vm.row.status].text))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }